export default __webpack_public_path__ + "static/media/ic_settings.e5ceed5a.svg";